export const ASSOCIATED_DATA_LIST_FETCH_FOR_DATASET_ID = 'ASSOCIATED_DATA_LIST_FETCH_FOR_DATASET_ID';
export const ASSOCIATED_DATA_DELETE_BY_ID = 'ASSOCIATED_DATA_DELETE_BY_ID';
